"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TAX_TYPES = void 0;
exports.TAX_TYPES = {
    IMPORT_FEE: 'Import fee',
    SALES_TAX: 'Sales Tax',
    GST: 'GST',
    INTERNATIONAL_TAXES: 'International Taxes'
};
//# sourceMappingURL=taxation.js.map